const ALGIERS_TIME_ZONE = 'Africa/Algiers';

export const formatAlgiersDateTime = (value) => {
    if (!value) return '';

    const rawValue = String(value).trim();
    const isoValue = rawValue.indexOf('T') === -1 ? rawValue.replace(' ', 'T') : rawValue;
    const utcValue = /(?:Z|[+-]\d{2}:?\d{2})$/.test(isoValue) ? isoValue : `${isoValue}Z`;
    const date = new Date(utcValue);

    if (Number.isNaN(date.getTime())) return rawValue;

    return new Intl.DateTimeFormat('fr-FR', {
        timeZone: ALGIERS_TIME_ZONE,
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
    }).format(date);
};
